import { Link } from 'react-router-dom';
import { Linkedin, Instagram } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-primary-dark text-text-inverse py-20" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div>
            <h3 className="font-heading text-2xl font-bold mb-4 group" data-testid="footer-logo">
              <span className="inline-block text-text-inverse">Growth</span>
              <span className="inline-block text-secondary-main">Pop</span>
              <span className="inline-block w-2 h-2 bg-secondary-main rounded-full ml-1 mb-1"></span>
            </h3>
            <p className="text-sm text-text-muted leading-relaxed mb-4">
              Strategic LinkedIn marketing for ambitious SMBs, MSBs and individuals worldwide. Transform your professional network into measurable business growth.
            </p>
            <div className="flex gap-3">
              <a
                href="https://www.linkedin.com/in/jassven-salluja"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-secondary-main rounded-full flex items-center justify-center transition-all group"
                data-testid="footer-linkedin"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5 text-text-inverse group-hover:text-primary-dark" />
              </a>
              <a
                href="https://www.instagram.com/jassvensalluja"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-secondary-main rounded-full flex items-center justify-center transition-all group"
                data-testid="footer-instagram"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5 text-text-inverse group-hover:text-primary-dark" />
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="font-body font-semibold mb-4 uppercase tracking-widest text-xs" data-testid="footer-quick-links-heading">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-text-muted hover:text-secondary-main transition-colors" data-testid="footer-link-home">Home</Link></li>
              <li><Link to="/services" className="text-sm text-text-muted hover:text-secondary-main transition-colors" data-testid="footer-link-services">Services</Link></li>
              <li><Link to="/testimonials" className="text-sm text-text-muted hover:text-secondary-main transition-colors" data-testid="footer-link-testimonials">Testimonials</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-body font-semibold mb-4 uppercase tracking-widest text-xs" data-testid="footer-services-heading">Services</h4>
            <ul className="space-y-2">
              <li><span className="text-sm text-text-muted">Profile Optimization</span></li>
              <li><span className="text-sm text-text-muted">Content Strategy</span></li>
              <li><span className="text-sm text-text-muted">Lead Generation</span></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-body font-semibold mb-4 uppercase tracking-widest text-xs" data-testid="footer-contact-heading">Contact</h4>
            <ul className="space-y-2">
              <li><a href="mailto:infor@growthpop.in" className="text-sm text-text-muted hover:text-secondary-main transition-colors" data-testid="footer-email">infor@growthpop.in</a></li>
              <li><Link to="/enquiry" className="text-sm text-text-muted hover:text-secondary-main transition-colors" data-testid="footer-link-enquiry">Get in Touch</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-white/10 mt-12 pt-8 text-center">
          <p className="text-sm text-text-muted" data-testid="footer-copyright">
            &copy; 2025 GrowthPop All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;